import { render, staticRenderFns } from "./table-configuration.vue?vue&type=template&id=4c009109&"
import script from "./table-configuration.vue?vue&type=script&lang=js&"
export * from "./table-configuration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports